import { Grid } from '@mui/material'
import { SectionHeading } from 'Components/Section'
import { HistoryForm2 } from '../Organisms/HistoryForm2'

const HistoryPage2 = () => {
  return (
    <Grid container rowSpacing={4}>
      <Grid item xs={12}>
        <SectionHeading />
      </Grid>

      <Grid item xs={12}>
        <HistoryForm2 />
      </Grid>
    </Grid>
  )
}

export default HistoryPage2
